/* eslint-disable max-len */
import React from 'react';

export const downArrow = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="16px"
    height="16px"
    viewBox="74 4 24 24"
    enableBackground="new 74 4 24 24"
  >
    <path d="M74.6,9.7c0.2,0,0.3,0.1,0.4,0.2c3.6,3.6,8.2,8.3,10.9,11c2.8-2.7,8.3-8.2,11-11c0.3-0.3,0.5-0.3,0.8,0c0.3,0.3,0.3,0.5,0,0.8c-3.8,3.8-8.6,8.5-11.4,11.4c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3-0.1-0.4-0.2c-3.8-3.8-8.5-8.5-11.3-11.4c-0.3-0.3-0.3-0.5-0.1-0.7C74.3,9.9,74.5,9.8,74.6,9.7z" />
  </svg>
);

export const upArrow = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="16px"
    height="16px"
    viewBox="74 4 24 24"
    enableBackground="new 74 4 24 24"
  >
    <path d="M97.4,22.2c-0.2,0-0.3-0.1-0.4-0.2c-3.7-3.7-8.2-8.3-11-11c-2.8,2.8-8.3,8.3-11.1,11.1c-0.3,0.3-0.5,0.3-0.8,0c-0.2-0.3-0.2-0.6,0-0.8c3.8-3.8,8.6-8.5,11.5-11.4c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c3.8,3.8,8.5,8.5,11.4,11.4c0.2,0.3,0.2,0.6,0,0.8C97.7,22.2,97.6,22.2,97.4,22.2z" />
  </svg>
);

export const check = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
    <path d="M18.259 31.519l18.011-19.203c0.378-0.403 1.011-0.423 1.413-0.045s0.423 1.011 0.045 1.413l-18.759 20c-0.402 0.428-1.084 0.42-1.475-0.018l-7.241-8.106c-0.368-0.412-0.332-1.044 0.079-1.412s1.044-0.332 1.412 0.079l6.514 7.291z" />
  </svg>
);

export const chatBotIcon = (
  <svg width="119" height="77" viewBox="0 0 119 77" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7393:162716)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.81182 5.92285H65.3118C68.5979 5.92285 71.2618 8.58676 71.2618 11.8729V47.5729C71.2618 50.8589 68.5979 53.5229 65.3118 53.5229H59.3618L49.8418 65.4229L40.3218 53.5229H5.81182C2.52572 53.5229 -0.138184 50.8589 -0.138184 47.5729V11.8729C-0.138184 8.58676 2.52572 5.92285 5.81182 5.92285Z"
        fill="#0074DE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.8417 25.8301C52.4706 25.8301 54.6017 27.9612 54.6017 30.5901C54.6017 33.219 52.4706 35.3501 49.8417 35.3501C47.2129 35.3501 45.0817 33.219 45.0817 30.5901C45.0817 27.9612 47.2129 25.8301 49.8417 25.8301ZM35.5617 25.8301C38.1906 25.8301 40.3217 27.9612 40.3217 30.5901C40.3217 33.219 38.1906 35.3501 35.5617 35.3501C32.9329 35.3501 30.8017 33.219 30.8017 30.5901C30.8017 27.9612 32.9329 25.8301 35.5617 25.8301ZM21.2817 25.8301C23.9106 25.8301 26.0417 27.9612 26.0417 30.5901C26.0417 33.219 23.9106 35.3501 21.2817 35.3501C18.6529 35.3501 16.5217 33.219 16.5217 30.5901C16.5217 27.9612 18.6529 25.8301 21.2817 25.8301Z"
        fill="white"
      />
      <path
        d="M105.772 67.8032C99.1592 67.497 98.6317 58.2832 98.6317 58.2832C98.6317 58.2832 98.1041 67.497 91.4917 67.8032C98.1042 68.1094 98.6317 77.3232 98.6317 77.3232C98.6317 77.3232 99.1593 68.1164 105.772 67.8032Z"
        fill="#FFC43A"
      />
      <path
        d="M90.3017 51.1432C88.0976 51.0284 87.9217 47.5732 87.9217 47.5732C87.9217 47.5732 87.7459 51.0284 85.5417 51.1432C87.7459 51.2581 87.9217 54.7132 87.9217 54.7132C87.9217 54.7132 88.0976 51.2607 90.3017 51.1432Z"
        fill="#FFF8D1"
      />
      <path
        d="M68.8817 64.2331C65.5754 64.08 65.3117 59.4731 65.3117 59.4731C65.3117 59.4731 65.0479 64.08 61.7417 64.2331C65.048 64.3862 65.3117 68.9931 65.3117 68.9931C65.3117 68.9931 65.5755 64.3897 68.8817 64.2331Z"
        fill="#1072EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_7393:162716">
        <rect width="119" height="77" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
